import React, { useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  TabItem,
  Table,
  Tabs,
  Timeline,
} from "flowbite-react";
import ReactApexChart from "react-apexcharts";
import { PAYMENTS, QUERIES } from "../config/apiConfig";
import { useQuery } from "react-query";
import axios from "../config/axiosInstance";
import moment from "moment";
import { Link } from "react-router-dom";
import { formatToReal } from "../utils/utils";
import DrawerLoading from "./DrawerLoading";
import { MdOutlineManageSearch } from "react-icons/md";
import { useApplication } from "../contexts/ApplicationContext";
import { GiReceiveMoney } from "react-icons/gi";
import { IoIosPerson, IoMdBusiness } from "react-icons/io";
import { FaMoneyBills } from "react-icons/fa6";
import { GoLinkExternal } from "react-icons/go";
import { Tooltip } from "react-tooltip";
import { FiAlertTriangle } from "react-icons/fi";

const Dashboard = ({ children }) => {
  const { user, userPermission } = useApplication();
  const {
    isLoading,
    error: errorDashboardInfos,
    data: dashboardInfos,
  } = useQuery(["dashboardInfos"], async () => {
    const { data } = await axios.get(`${QUERIES.GET_DASHBOARD_INFOS}`);

    return data.data;
  });

  const {
    isLoading: isLoadingRepresentatives,
    error: errorDashboardInfosRepresentatives,
    data: dashboardInfosRepresentative,
  } = useQuery(
    ["dashboardInfosRepresentative"],
    async () => {
      const { data } = await axios.get(
        `${QUERIES.GET_DASHBOARD_INFOS_REPRESENTATIVE}`
      );

      return data.data;
    },
    {
      enabled: user?.Company?.companyTypeId === "REPRESENTANTE",
    }
  );

  const {
    isLoading: isLoadingPowerUser,
    error: errorDashboardInfosPowerUsers,
    data: dashboardInfosPowerUser,
  } = useQuery(
    ["dashboardInfosPowerUser"],
    async () => {
      const { data } = await axios.get(
        `${QUERIES.GET_DASHBOARD_INFOS_POWER_USER}`
      );

      return data.data;
    },
    {
      enabled: userPermission === "POWER_USER",
    }
  );

  const {
    isLoading: isLoadingInvoicesOpen,
    error: errorInvoicesOpen,
    data: invoicesOpen,
  } = useQuery(["invoicesOpen"], async () => {
    const { data } = await axios.get(`${PAYMENTS.OPEN_PAYMENTS}`);

    return data.data;
  });

  return (
    <>
      <div className="rounded-lg dark:border-gray-700 mt-3">
        {user?.Company?.companyTypeId === "REPRESENTANTE" &&
          userPermission === "ADMIN" && (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-4">
              <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
                <div>
                  <div className="font-semibold text-gray-500 text-sm">
                    Total a receber / Dia
                  </div>
                  <div className="font-semibold flex gap-2 items-end">
                    <Badge className="text-2xl" color="purple">
                      {formatToReal(
                        dashboardInfosRepresentative?.totalInvoiceToday || 0
                      )}
                    </Badge>
                  </div>
                  <div className="text-sm">total de faturamento</div>
                </div>

                <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                  <FaMoneyBills color="white" fontSize={30} />
                </div>
                {isLoadingRepresentatives && <DrawerLoading />}
              </div>
              <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
                <div>
                  <div className="font-semibold text-gray-500 text-sm">
                    Total a receber / mês
                  </div>
                  <div className="font-semibold flex gap-2 items-end">
                    <Badge className="text-2xl" color="green">
                      {formatToReal(
                        dashboardInfosRepresentative?.totalInvoiceMonth || 0
                      )}
                    </Badge>
                  </div>
                  <div className="text-sm">faturamento</div>
                </div>

                <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                  <GiReceiveMoney color="white" fontSize={30} />
                </div>
                {isLoadingRepresentatives && <DrawerLoading />}
              </div>
              <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
                <div>
                  <div className="font-semibold text-gray-500 text-sm">
                    Qtd. Total de Clientes
                  </div>
                  <div className="font-semibold flex gap-2 items-end">
                    <Badge className="text-2xl" color="indigo">
                      {dashboardInfosRepresentative?.totalCustomerQuantity}
                    </Badge>
                  </div>
                  <div className="text-sm">de clientes</div>
                </div>

                <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                  <IoIosPerson color="white" fontSize={30} />
                </div>
                {isLoadingRepresentatives && <DrawerLoading />}
              </div>
              <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
                <div>
                  <div className="font-semibold text-gray-500 text-sm">
                    Qtd. Total de represent.
                  </div>
                  <div className="font-semibold flex gap-2 items-end">
                    <Badge className="text-2xl">
                      {
                        dashboardInfosRepresentative?.totalRepresentativeQuantity
                      }
                    </Badge>
                  </div>
                  <div className="text-sm">de representantes</div>
                </div>

                <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                  <IoMdBusiness color="white" fontSize={30} />
                </div>
                {isLoadingRepresentatives && <DrawerLoading />}
              </div>
            </div>
          )}

        {userPermission === "POWER_USER" && (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-4">
            <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
              <div>
                <div className="font-semibold text-gray-500 text-sm">
                  Total a receber / Dia
                </div>
                <div className="font-semibold flex gap-2 items-end">
                  <Badge className="text-2xl" color="purple">
                    {formatToReal(
                      dashboardInfosPowerUser?.totalInvoiceToday || 0
                    )}
                  </Badge>
                </div>
                <div className="text-sm">total de faturamento</div>
              </div>

              <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                <FaMoneyBills color="white" fontSize={30} />
              </div>
              {isLoadingPowerUser && <DrawerLoading />}
            </div>
            <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
              <div>
                <div className="font-semibold text-gray-500 text-sm">
                  Total a receber / mês
                </div>
                <div className="font-semibold flex gap-2 items-end">
                  <Badge className="text-2xl" color="green">
                    {formatToReal(
                      dashboardInfosPowerUser?.totalInvoiceMonth || 0
                    )}
                  </Badge>
                </div>
                <div className="text-sm">faturamento</div>
              </div>

              <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                <GiReceiveMoney color="white" fontSize={30} />
              </div>
              {isLoadingPowerUser && <DrawerLoading />}
            </div>
            <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
              <div>
                <div className="font-semibold text-gray-500 text-sm">
                  Qtd. total de clientes
                </div>
                <div className="font-semibold flex gap-2 items-end">
                  <Badge className="text-2xl" color="indigo">
                    {dashboardInfosPowerUser?.totalCustomerQuantity}
                  </Badge>
                </div>
                <div className="text-sm">de clientes</div>
              </div>

              <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                <IoIosPerson color="white" fontSize={30} />
              </div>
              {isLoadingPowerUser && <DrawerLoading />}
            </div>
            <div className="shadow p-3 rounded-lg border border-gray-200 bg-white relative flex items-center justify-between">
              <div>
                <div className="font-semibold text-gray-500 text-sm">
                  Qtd. total de represent.
                </div>
                <div className="font-semibold flex gap-2 items-end">
                  <Badge className="text-2xl">
                    {dashboardInfosPowerUser?.totalRepresentativeQuantity}
                  </Badge>
                </div>
                <div className="text-sm">de representantes</div>
              </div>

              <div className="bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 p-2 w-16 h-16 rounded flex items-center justify-center">
                <IoMdBusiness color="white" fontSize={30} />
              </div>
              {isLoadingPowerUser && <DrawerLoading />}
            </div>
          </div>
        )}

        {invoicesOpen?.length > 0 && (
          <Alert className="mb-4" color="warning" withBorderAccent>
            <div>
              Atenção! Você possui <b>({invoicesOpen?.length})</b> pagamentos em
              aberto!{" "}
              <Link to="/invoices" className="underline">
                Clique aqui para visualizar
              </Link>
            </div>
          </Alert>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4 mb-4">
          {user?.Company?.companyTypeId === "CLIENTE" ? (
            <Card className="card-dashboard relative">
              <Tabs aria-label="Default tabs" variant="default">
                <TabItem active title="Informações">
                  <div className="flex flex-col gap-3">
                    <div className="flex gap-2 items-center mb-1">
                      <div>Plano Contratado:</div>
                      <div className="rounded-md bg-primary text-white w-fit p-2 font-semibold">
                        {user?.Company?.typePayment === "POS"
                          ? "Pós-Pago"
                          : "Pré-Pago"}
                      </div>
                    </div>

                    <div className="flex gap-2 items-center">
                      <div>Data de cadastro no sistema:</div>
                      <div className="font-semibold">
                        {moment(user?.Company?.createdAt).format("DD/MM/yyyy")}
                      </div>
                    </div>

                    {user?.Company?.typePayment === "PRE" && (
                      <>
                        <div className="flex gap-2 items-center">
                          <div>Saldo:</div>
                          <div className="font-semibold">
                            {formatToReal(user?.Company?.credit)}
                          </div>
                        </div>

                        {user?.Company?.credit <= 10 &&
                          user?.Company?.credit > 0 && (
                            <Alert color="warning" withBorderAccent>
                              Seu saldo está acabando. Faça uma recarga para
                              poder realizar mais consultas.
                            </Alert>
                          )}

                        {user?.Company?.credit == 0 && (
                          <Alert color="failure" withBorderAccent>
                            Seu saldo acabou! Faça uma recarga para poder
                            realizar mais consultas.
                          </Alert>
                        )}
                      </>
                    )}

                    {user?.Company?.typePayment === "POS" && (
                      <>
                        <div className="flex gap-2 items-center">
                          <div>Utilização mínima mensal:</div>
                          <div className="font-semibold">
                            {formatToReal(user?.Company?.vcm)}
                          </div>
                        </div>

                        <div className="flex gap-2 items-center">
                          <div>Limite máximo para utilizar:</div>
                          <div className="font-semibold">
                            {formatToReal(user?.Company?.limitUse)}
                          </div>
                        </div>

                        {+user?.Company?.limitUse !== 0 &&
                          +user?.Company?.limitUse -
                            +dashboardInfos?.totalPriceUsedMonth <=
                            15 &&
                          +user?.Company?.limitUse -
                            +dashboardInfos?.totalPriceUsedMonth >
                            0 && (
                            <Alert color="warning" withBorderAccent>
                              Você está chegando no seu limite de uso mensal.
                            </Alert>
                          )}

                        {+user?.Company?.limitUse !== 0 &&
                          +user?.Company?.limitUse -
                            +dashboardInfos?.totalPriceUsedMonth <=
                            0 && (
                            <Alert color="failure" withBorderAccent>
                              Você atingiu seu limite mensal.
                            </Alert>
                          )}
                      </>
                    )}
                  </div>
                </TabItem>
                {user?.Company?.typePayment === "POS" && (
                  <TabItem
                    title={`Pagamentos (${dashboardInfos?.totalPendingExpiredInvoices?.length})`}
                  >
                    <div
                      className="overflow-y-auto"
                      style={{ maxHeight: "300px" }}
                    >
                      {dashboardInfos?.totalPendingExpiredInvoices?.length >
                      0 ? (
                        <div className="rounded-md overflow-hidden border border-gray-100 mt-3">
                          <Table striped className="w-full">
                            <Table.Head>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Tipo
                              </td>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Dt. Criação
                              </td>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Dt. Vencimento
                              </td>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Valor
                              </td>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Ações
                              </td>
                            </Table.Head>
                            <Table.Body>
                              {dashboardInfos?.totalPendingExpiredInvoices?.map(
                                (info, index) => (
                                  <tr
                                    key={index}
                                    className={`${
                                      index % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-100"
                                    }`}
                                  >
                                    <td className="p-1 text-center">
                                      {info?.type}
                                    </td>
                                    <td className="p-1 text-center">
                                      {moment(info?.createdAt).format(
                                        "DD/MM/yyyy"
                                      )}
                                    </td>
                                    <td className="p-1 text-center">
                                      {moment(info?.dueDate).format(
                                        "DD/MM/yyyy"
                                      )}
                                    </td>
                                    <td className="p-1 text-center">
                                      {formatToReal(info?.price)}
                                    </td>
                                    <td className="p-1 text-center">
                                      <Tooltip
                                        id="tooltip-link"
                                        content="Visualizar boleto"
                                      />
                                      <a
                                        data-tooltip-id="tooltip-link"
                                        href={info.paymentLink}
                                        target="_blank"
                                        className="inline-block mt-1"
                                      >
                                        <GoLinkExternal fontSize={16} />
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      ) : (
                        <div className="flex justify-center items-center h-40 md:h-60 text-sm md:text-base font-semibold">
                          <MdOutlineManageSearch
                            fontSize={25}
                            className="mr-2"
                          />{" "}
                          Nenhum pagamento pendente!
                        </div>
                      )}
                    </div>
                  </TabItem>
                )}
              </Tabs>

              {isLoading && <DrawerLoading />}
            </Card>
          ) : (
            <Card className="card-dashboard relative">
              <Tabs aria-label="Default tabs" variant="default">
                <TabItem active title="Consultas">
                  <div className="title-syncx">
                    Clientes com mais consultas hoje
                  </div>
                  {dashboardInfos?.mostQueriesDaily?.length > 0 ? (
                    <div className="rounded-md overflow-hidden border border-gray-100 mt-3">
                      <Table striped className="w-full">
                        <Table.Head>
                          <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                            Cliente
                          </td>
                          <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                            Tipo de pagamento
                          </td>
                          <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                            Qtd. de consultas/dia
                          </td>
                        </Table.Head>
                        <Table.Body>
                          {dashboardInfos?.mostQueriesDaily?.map(
                            (info, index) => (
                              <tr
                                key={index}
                                className={`${
                                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                }`}
                              >
                                <td className="p-1">
                                  {info.companyTypeCompany === "CPF"
                                    ? info.companyName
                                    : info.companySocialReason}
                                </td>
                                <td className="p-1 text-center">
                                  {info.companyTypePayment}
                                </td>
                                <td className="p-1 text-center font-semibold">
                                  {info.queryCount}
                                </td>
                              </tr>
                            )
                          )}
                        </Table.Body>
                      </Table>
                    </div>
                  ) : (
                    <div className="flex justify-center items-center h-40 md:h-60 text-sm md:text-base font-semibold">
                      <MdOutlineManageSearch fontSize={25} className="mr-2" />{" "}
                      Nenhum cliente realizou consultas hoje!
                    </div>
                  )}
                </TabItem>
                {userPermission === "POWER_USER" && (
                  <TabItem title={`Pagamentos`}>
                    <div className="title-syncx">
                      Vencidos / Próximos de vencer
                    </div>
                    <div
                      className="overflow-y-auto"
                      style={{ maxHeight: "300px" }}
                    >
                      {dashboardInfosPowerUser?.totalPendingExpiredInvoices
                        ?.length > 0 ? (
                        <div className="rounded-md overflow-hidden border border-gray-100 mt-3">
                          <Table striped className="w-full">
                            <Table.Head>
                              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                                <div>Cliente</div>
                              </td>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Dt. Vencimento
                              </td>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Valor
                              </td>
                              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                Ações
                              </td>
                            </Table.Head>
                            <Table.Body>
                              {dashboardInfosPowerUser?.totalPendingExpiredInvoices?.map(
                                (info, index) => (
                                  <tr
                                    key={index}
                                    className={`${
                                      index % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-100"
                                    }`}
                                  >
                                    <td className="p-1">
                                      <div className="-mb-1">
                                        {info?.Company?.name ||
                                          info?.Company?.socialReason}
                                      </div>
                                      <a
                                        href={`https://wa.me/55${info?.Company?.phoneNumber?.replace(
                                          /\D/g,
                                          ""
                                        )}`}
                                        target="_blank"
                                        className="text-2xs -mt-1 text-green-500 underline"
                                      >
                                        Tel: {info?.Company?.phoneNumber}
                                      </a>
                                    </td>
                                    <td className="p-1 text-center">
                                      {moment(info?.dueDate).format(
                                        "DD/MM/yyyy"
                                      )}
                                    </td>
                                    <td className="p-1 text-center">
                                      {formatToReal(info?.price)}
                                    </td>
                                    <td className="p-1 text-center">
                                      <Tooltip
                                        id="tooltip-link"
                                        content="Visualizar boleto"
                                      />
                                      <a
                                        data-tooltip-id="tooltip-link"
                                        href={info.paymentLink}
                                        target="_blank"
                                        className="inline-block mt-1"
                                      >
                                        <GoLinkExternal fontSize={16} />
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      ) : (
                        <div className="flex justify-center items-center h-40 md:h-60 text-sm md:text-base font-semibold">
                          <MdOutlineManageSearch
                            fontSize={25}
                            className="mr-2"
                          />{" "}
                          Nenhum pagamento pendente!
                        </div>
                      )}
                    </div>
                  </TabItem>
                )}
              </Tabs>

              {isLoading && <DrawerLoading />}
            </Card>
          )}
          <Card className="card-dashboard relative">
            <div className="title-syncx">Histórico de consultas</div>
            {!isLoading && dashboardInfos?.lastQueriesBy7Days?.length > 0 && (
              <ReactApexChart
                options={{
                  chart: {
                    height: 350,
                    type: "bar",
                    events: {
                      click: function (chart, w, e) {
                        // console.log(chart, w, e)
                      },
                    },
                    toolbar: {
                      show: false,
                    },
                  },
                  plotOptions: {
                    bar: {
                      columnWidth: "45%",
                      distributed: true,
                    },
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  legend: {
                    show: false,
                  },
                  xaxis: {
                    categories: dashboardInfos?.lastQueriesBy7Days?.map(
                      (obj) => {
                        const [, month, day] = obj.date.split("-");
                        return `${day}/${month}`;
                      }
                    ),
                    labels: {
                      style: {
                        fontSize: "12px",
                      },
                    },
                  },
                }}
                series={[
                  {
                    name: "Qtd. de consultas",
                    data: dashboardInfos?.lastQueriesBy7Days?.map(
                      (obj) => obj.totalQueries
                    ),
                  },
                ]}
                type="bar"
                height={350}
              />
            )}

            {isLoading && <DrawerLoading />}
          </Card>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mb-4">
          <Card className="card-dashboard relative">
            <div className="flex justify-between items-center">
              <div className="title-syncx">Últimas consultas</div>
              <Button size="xs">
                <Link to="/reports/queries">Ver detalhes</Link>
              </Button>
            </div>
            {!isLoading && (
              <>
                {dashboardInfos?.lastQueries?.length > 0 ? (
                  <Timeline>
                    {dashboardInfos?.lastQueries?.map((query, index) => (
                      <Timeline.Item key={index} className="mb-2">
                        <Timeline.Point />
                        <Timeline.Content>
                          <Timeline.Time>
                            {moment(query.createdAt).format("DD/MM/YY - HH:mm")}
                            h
                          </Timeline.Time>
                          <Timeline.Title className="text-base">
                            Consulta: {query.queryName}
                          </Timeline.Title>
                          <Timeline.Body className="text-sm mb-0">
                            Usuário: {query.userName}
                          </Timeline.Body>
                        </Timeline.Content>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                ) : (
                  <div className="text-center my-20 font-semibold flex flex-col gap-2 items-center text-gray-700">
                    <MdOutlineManageSearch
                      fontSize={26}
                      style={{ color: "var(--primary)" }}
                    />
                    <div>Nenhuma consulta realizada</div>
                  </div>
                )}
              </>
            )}
            {isLoading && <DrawerLoading />}
          </Card>
          <Card className="card-dashboard relative">
            <div className="flex items-center justify-between">
              <div className="title-syncx">Produtos mais consultados / mês</div>
            </div>
            <div className="flow-root">
              {dashboardInfos?.mostSearchedProductsMonth?.length > 0 ? (
                <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                  {dashboardInfos?.mostSearchedProductsMonth?.map(
                    (query, index) => (
                      <li key={index} className="pb-0 pt-3 pb-3">
                        <div className="flex items-center space-x-4">
                          <div className="min-w-0 flex-1">
                            <p className="truncate text-sm font-medium text-gray-900 dark:text-white">
                              {query.name}
                            </p>
                          </div>
                          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            {query.totalQueries}
                          </div>
                        </div>
                      </li>
                    )
                  )}
                </ul>
              ) : (
                <div className="text-center my-20 font-semibold flex flex-col gap-2 items-center text-gray-700">
                  <MdOutlineManageSearch
                    fontSize={26}
                    style={{ color: "var(--primary)" }}
                  />
                  <div>Nenhum produto consultado</div>
                </div>
              )}
            </div>
            {isLoading && <DrawerLoading />}
          </Card>
          <Card className="card-dashboard relative">
            <div className="title-syncx">Total de consultas / mês</div>
            <div className="flex gap-2 flex-col">
              <div className="flex flex-col gap-1">
                <span className="text-base font-semibold">
                  Total de consultas até o momento:
                </span>
                <Badge className="w-fit shadow" size="lg" color="green">
                  {dashboardInfos?.totalCurrentMonth?.totalQueries || 0}
                </Badge>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-base font-semibold">
                  Total de consultas previstas:
                </span>
                <Badge className="w-fit shadow" size="lg" color="gray">
                  {dashboardInfos?.totalCurrentMonth?.estimatedQueries}
                </Badge>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-base font-semibold">Média diária:</span>
                <Badge className="w-fit shadow" size="lg" color="gray">
                  {Math.ceil(dashboardInfos?.totalCurrentMonth?.averageDaily)}
                </Badge>
              </div>
            </div>
            <Alert color="info">
              A previsão é baseada na quantidade média de consultas diárias
            </Alert>
            {isLoading && <DrawerLoading />}
          </Card>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
